import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { fetchAccounts } from './functions';
import { AccountsPropsContext } from './PropsContext';
import { FETCH_ACCOUNTS, initialState, reducer } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const AccountsContext = /*#__PURE__*/createContext(initialState);
export const AccountsContextProvider = ({
  children
}) => {
  const [accounts, dispatchCTX] = useReducer(loggingMiddleware('accounts')(reducer), initialState);
  const {
    apiWrapper
  } = useContext(AccountsPropsContext);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    apiWrapper
  }), [apiWrapper]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case FETCH_ACCOUNTS:
        fetchAccounts(asyncFuncArg);
        break;
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  const actions = useMemo(() => ({
    fetchAccounts: () => dispatch({
      type: FETCH_ACCOUNTS
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, accounts, {
    dispatch,
    accountsActions: actions
  }), [accounts, dispatch, actions]);
  return /*#__PURE__*/_jsx(AccountsContext.Provider, {
    value: state,
    children: children
  });
};